import { render } from "./EconomicReport.vue?vue&type=template&id=41fa7cd5&ts=true"
import script from "./EconomicReport.vue?vue&type=script&lang=ts"
export * from "./EconomicReport.vue?vue&type=script&lang=ts"

import "./EconomicReport.vue?vue&type=style&index=0&id=41fa7cd5&lang=css"

import exportComponent from "D:\\a\\1\\s\\cst\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__